import React, { Component, Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import API from '../../../utils/API';
import LoadingWizard from '../../../components/spinner/wizard';
import ReportsContainer from '../../../components/views/ReportsContainer';
import SectionFooter from '../../../components/views/SectionFooter';
import FieldModal from '../../../components/modals/fieldModal';
import InputField from '../../../components/inputs/inputField';
import TextAreaField from '../../../components/inputs/textAreaField';
import CreateTemplateFromReportModal from './modals/CreateTemplateFromReportModal';
import AlertBar from '../../../components/custom/alertBar';
import ToggleField from '../../../components/inputs/toggleField';

class EventReport extends Component {
    constructor(props) {
        super(props);
        const reportId = props.match.params.report;
        const report = props.reports.find(r => r._id == reportId);
        this.state = {
            report,
            updatedReport: { ...report },
            eventId: props.eventId,
            loading: false,
            editDetailsOpen: false,
            saveAsTemplateOpen: false,
            editing: false,
            graphOrderChanged: false,  
            currentGraphs: null       
        };
    }

    updateReportDetails = async (cb) => {
        const { orgId, eventId } = this.props;
        const { updatedReport } = this.state;
        const res = await API().patch(`Organizations/${orgId}/events/${eventId}/viewReports/${updatedReport._id}`, updatedReport);
        if (res.data) {
            this.setState({ report: { ...res.data, lastEditedBy: res.data.lastEditedBy }, updatedReport: { ...res.data, lastEditedBy: res.data.lastEditedBy } }, () => {
                const reportId = this.props.match.params.report;
                const report = this.props.reports.find(r => r._id == reportId);
                report.name = res.data.name;
                report.description = res.data.description;
                this.props.updateReport(report);
                cb && cb();
            });

        }
    }
    handleGraphOrderChange = (isChanged, updatedGraphs) => {
        this.setState({ 
            editing: isChanged,
            currentGraphs: isChanged ? updatedGraphs : null 
        });
    }
    saveGraphOrder = async () => {
        const { orgId, eventId } = this.props;
        const { currentGraphs, graphs, updatedReport } = this.state;
        const graphOrder = currentGraphs.map(g => g._id);
        
        try {
            this.setState({ submitting: true });
            
            // Send the complete array of graphs in the new order
            const res = await API().patch(`/Organizations/${orgId}/events/${eventId}/viewReports/${updatedReport._id}`, {
                graphOrder: graphOrder
            });
            
            if (res.data) {
                // Update state with the response
                this.setState({
                    editing: false,
                    submitting: false
                });
            }
        } catch (error) {
            console.error('Error saving graph order:', error);
            this.setState({
                error: 'Failed to save graph order',
                submitting: false
            });
        }
    };
    
    cancelGraphOrder = () => {
        this.setState({
            editing: false,
            currentGraphs: null
        });
        
        if (this.reportsContainerRef && this.reportsContainerRef.restoreOriginalOrder) {
            this.reportsContainerRef.restoreOriginalOrder();
        }
    }


    updateReportShareList = async (shareList, cb) => {
        const { orgId, eventId } = this.props;
        const { updatedReport } = this.state;
        const res = await API().patch(`Organizations/${orgId}/events/${eventId}/viewReports/${updatedReport._id}`, { sharedWith: shareList });
        if (res.data) {
            this.setState({ report: res.data, updatedReport: { ...res.data } }, cb);
        }
    }

    pinView = async (viewId) => {
        const updatedReport = this.state.report;
        updatedReport.pins.push(viewId);
        this.setState({ updatedReport }, this.updateReport);
    }

    unpinView = async (viewId) => {
        const updatedReport = this.state.report;
        updatedReport.pins = updatedReport.pins.filter(p => p !== viewId);
        this.setState({ updatedReport }, this.updateReport);
    }

    toggleEditDetails = () => {
        this.setState({ editDetailsOpen: !this.state.editDetailsOpen });
    }

    toggleSaveAsTemplate = () => {
        this.setState({ saveAsTemplateOpen: !this.state.saveAsTemplateOpen });
    }

    addReportView = (view) => {
        const updatedReport = this.state.report;
        updatedReport.views.push(view);
        this.setState({
            report: updatedReport,
        }, () => {
            this.props.updateReport(JSON.parse(JSON.stringify(updatedReport)));
        });
    };

    updateReportView = (view) => {
        const reportId = this.props.match.params.report;
        const report = this.props.reports.find(r => r._id == reportId);
        report.views = report.views.map(v => {
            if (v._id === view._id) {
                return { ...v, ...view };
            }
            return v;
        });
        this.setState({
            report: report,
        }, () => {
            this.props.updateReport(JSON.parse(JSON.stringify(report)));
        });
    }

    removeView = (viewId) => {
        const updatedReport = this.state.report;
        updatedReport.views = updatedReport.views.filter(v => v._id !== viewId);
        this.setState({
            report: updatedReport,
        }, () => {
            this.props.updateReport(JSON.parse(JSON.stringify(updatedReport)));
        });
    }

    render() {
        const {
            report,
            updatedReport,
            eventId,
            loading,
            editing,
            editDetailsOpen,
            saveAsTemplateOpen
        } = this.state;
        const { event, orgId, favoriteReport } = this.props;
        const eventGroups = event.groups.map(group => {
            return {
                ...group,
                attendees: group.attendees
                    .map(attendeeId => {
                        const matchedAttendee = event.attendees.find(attendee => attendee.id === attendeeId);
                        return matchedAttendee ? `${matchedAttendee.firstName} ${matchedAttendee.lastName}` : attendeeId;
                    })
                    .join(', '),
                sessions: group.sessions
                    .map(sessionId => {
                        const matchedSession = event.sessions.find(session => session.id === sessionId);
                        return matchedSession ? matchedSession.name : sessionId;
                    })
                    .join(', '), 
            };
        });
        const formSubmissions = event.forms.flatMap(form =>
            form.submissions.map(submission => {
                // Parse extraFields if it's a string
                let extraFields = {};
                if (submission.formData.extraFields) {
                    try {
                        extraFields = typeof submission.formData.extraFields === "string"
                            ? JSON.parse(submission.formData.extraFields)
                            : submission.formData.extraFields;
                    } catch (e) {
                        extraFields = {};
                    }
                }

                // Ensure attendee fields are not empty
                const attendeeEmail = submission.formData.attendeeEmail && submission.formData.attendeeEmail !== ""
                ? submission.formData.attendeeEmail
                : (submission.formData.email && submission.formData.email !== ""
                    ? submission.formData.email
                    : (submission.attendee && submission.attendee.email && submission.attendee.email !== ""
                        ? submission.attendee.email
                        : "-"));
            
            const attendeeFirstName = submission.formData.attendeeFirstName && submission.formData.attendeeFirstName !== ""
                ? submission.formData.attendeeFirstName
                : (submission.formData.firstName && submission.formData.firstName !== "" 
                    ? submission.formData.firstName 
                    : (submission.attendee && submission.attendee.firstName && submission.attendee.firstName !== ""
                        ? submission.attendee.firstName
                        : "-"));
            
            const attendeeLastName = submission.formData.attendeeLastName && submission.formData.attendeeLastName !== ""
                ? submission.formData.attendeeLastName
                : (submission.formData.lastName && submission.formData.lastName !== "" 
                    ? submission.formData.lastName 
                    : (submission.attendee && submission.attendee.lastName && submission.attendee.lastName !== ""
                        ? submission.attendee.lastName
                        : "-"));
            
            const email = submission.formData.email && submission.formData.email !== ""
                ? submission.formData.email
                : (submission.attendee && submission.attendee.email && submission.attendee.email !== ""
                    ? submission.attendee.email
                    : "-");

                return {
                    ...submission.formData,
                    ...extraFields,
                    attendeeEmail,
                    attendeeFirstName,
                    attendeeLastName,
                    email,
                    _id: submission._id,
                    submittedAt: submission.submittedAt,
                    formId: form._id,
                };
            })
        );
        return (
            <Fragment>
                {!loading && <div className='sectionContainer'>
                    {report.isOrgTemplate && <AlertBar style={{ paddingBottom: 20 }} message={"This report is a template. Changes made here will be applied to all future reports created from this template."} type="error" />}

                    <ReportsContainer
                        ref={ref => (this.reportsContainerRef = ref)}  
                        key={report._id}
                        report={report}
                        orgId={orgId}
                        onGraphOrderChange={this.handleGraphOrderChange} 
                        toggleEditDetails={this.toggleEditDetails}
                        toggleSaveAsTemplate={this.toggleSaveAsTemplate}
                        entries={{
                            Attendee: event.attendees,
                            Session: event.sessions,
                            Group: eventGroups,
                            Email: event.emails,
                            Text: event.texts,
                            Form: event.forms,
                            Page: event.pages,
                            Submission: formSubmissions,
                        }}
                        forms={event.forms}
                        title={report.name}
                        breadcrumbs={[
                            {
                                name: event.name
                            },
                            {
                                name: 'Reports'
                            }
                        ]}
                        //description={report.description}
                        readOnly={false}
                        mainActions={[]}
                        batchActions={[]}
                        enableDownloadViews={false}
                        referenceCollection='events'
                        referenceId={eventId}
                        eventId={eventId}
                        pinView={this.pinView}
                        unpinView={this.unpinView}
                        favoriteReport={favoriteReport}
                        updateReportShareList={this.updateReportShareList}
                        addReportView={this.addReportView}
                        updateReportView={this.updateReportView}
                        removeView={this.removeView}
                    />
                    <SectionFooter 
                    updatedAt={report.updatedAt} 
                    cancelEdit={this.cancelGraphOrder}
                    saveEdit={this.saveGraphOrder}
                    editing={editing}
                    lastEditedBy={updatedReport.lastEditedBy} />
                    {editDetailsOpen && <FieldModal isOpen={editDetailsOpen} toggle={this.toggleEditDetails} size="medium" modalTitle="Edit Details" bodyContent={() => {
                        return <div>
                            <InputField
                                label="Report Name"
                                required={true}
                                value={updatedReport.name}
                                onChange={(e) => this.setState({ updatedReport: { ...updatedReport, name: e.target.value } })}
                            />
                            <TextAreaField
                                label="Report Description"
                                value={updatedReport.description}
                                onChange={(e) => this.setState({ updatedReport: { ...updatedReport, description: e.target.value } })}
                            />
                            <ToggleField
                                label="Enable Graph Dashboard"
                                checked={updatedReport.enableGraphDashboard}
                                required={true}
                                icons={false}
                                onChange={(e) => this.setState({ updatedReport: { ...updatedReport, enableGraphDashboard: e.target.checked } })}
                            />
                        </div>
                    }} actionButton={() => this.updateReportDetails(this.toggleEditDetails)}
                        actionButtonDisabled={updatedReport.name === ""} actionButtonLabel="Save" cancelButtonLabel="Cancel"
                    />}
                    {saveAsTemplateOpen && (
                        <CreateTemplateFromReportModal
                            isOpen={saveAsTemplateOpen}
                            updateOrgReports={this.props.updateOrgReports}
                            email={{}}
                            orgId={orgId}
                            eventId={eventId}
                            event={event}
                            toggle={this.toggleSaveAsTemplate}
                            updatedReport={updatedReport}
                            updateReport={() => this.setState({ updatedReport: { ...updatedReport, isOrgTemplate: false } }, )}
                        />
                    )}
                </div>}

                <LoadingWizard loading={loading} text="Loading Report" />

            </Fragment>
        );
    }
}

export default withRouter(EventReport);
